import { processRead } from "./objectUtilities";

export const cleanFormDef = (def = [], cellFilter = () => true, props = {}) => {
  return def.map(section => {
    const rows = section?.rows?.map(row => row?.filter(cellFilter))
      .filter(row => row.length > 0);
    return { ...section, rows, ...props };
  }).filter(section => section.rows.length > 0);
};

export const buildInitDelta = (initialValueMapping, context) => {
    if (!initialValueMapping || !context) {
      return null;
    }
    
    if (initialValueMapping.length === 0) {
      return null;
    }
    const delta = processRead(context, initialValueMapping);
    return delta;
};